import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListPlanAnual from '../../../components/saude/documentos/planoanual';


function ListPlanAnualScreen() {
    return (
        <Fragment>
            <Head titulo="Programação Anual da Saúde em Macuco" />
            <Header />
            <Container>
               <ListPlanAnual /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListPlanAnualScreen;